import React from 'react';
import { Link } from 'react-router';

// The "hamburger button" component.
class NavButton extends React.Component {
    render() {
        return (
            <Link to="/" className="button-home">
                <i className="cl-icon cl-icon-home icon" aria-hidden="true" />
                <span className="aural">Home</span>
            </Link>
        );
    }
}

export default NavButton;



// WEBPACK FOOTER //
// ./src/components/navbar/container/navbutton.jsx